import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1634072a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "排行榜")
], -1))
const _hoisted_2 = { class: "tool-bar" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "card-body-header" }
const _hoisted_5 = {
  key: 0,
  class: "card-body-content"
}
const _hoisted_6 = {
  key: 1,
  class: "card-body-content"
}
const _hoisted_7 = { class: "card-item" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }

import { onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { getListData } from '@/service/main/system'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import { ElLoading } from 'element-plus'
import { useStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'RankingList',
  setup(__props) {

const dataList = ref([])
const allColumns = ref([
  { prop: 'groupName', label: '组名' },
  { prop: 'name', label: '姓名' },
  {
    prop: 'orderCount',
    sqlCol: 'order_count',
    label: '成交单量',
    type: 'option'
  },
  {
    prop: 'amountCount',
    sqlCol: 'amount_count',
    label: '成交金额',
    type: 'option'
  },
  { prop: 'rank', label: '排名' }
])

const columns: any = ref([])

const currentOption = ref('order_count')
const currentType = ref('year')
const year = ref(dayjs().format('YYYY'))
const month = ref(dayjs().format('YYYY-MM'))
const pageSize = ref('10')
const statisticType = ref('0')

const store = useStore()
const userInfo = store.state.login.userInfo

let loadingInstance: ILoadingInstance = {} as ILoadingInstance
const getData = () => {
  if (statisticType.value === '0') {
    columns.value = allColumns.value
  } else {
    columns.value = allColumns.value.filter((o) => o.prop != 'name')
  }

  loadingInstance = ElLoading.service({
    target: '.card-body-content'
  })
  getListData('/main/order/list', {
    year: currentType.value === 'year' ? year.value : month.value.split('-')[0],
    month: currentType.value === 'month' ? month.value.split('-')[1] : '',
    empTag: userInfo.empTag,
    orderBy: currentOption.value,
    orderType: 'desc',
    groupBy: currentType.value,
    limit: pageSize.value,
    statisticType: statisticType.value
  }).then((res) => {
    if (loadingInstance) {
      loadingInstance.close()
    }
    dataList.value = res
  })
}

onMounted(() => {
  getData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "card-ranking" }, {
    header: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_select, {
          style: {"width":"90px"},
          modelValue: statisticType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((statisticType).value = $event)),
          size: "mini",
          onChange: getData,
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "个人",
              value: "0"
            }),
            _createVNode(_component_el_option, {
              label: "小组",
              value: "1"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          style: {"width":"90px"},
          modelValue: pageSize.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
          size: "mini",
          onChange: getData,
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "前10名",
              value: "10"
            }),
            _createVNode(_component_el_option, {
              label: "全部",
              value: "0"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          style: {"width":"60px"},
          modelValue: currentType.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentType).value = $event)),
          size: "mini",
          onChange: getData,
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "年",
              value: "year"
            }),
            _createVNode(_component_el_option, {
              label: "月",
              value: "month"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (currentType.value === 'year')
          ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 0,
              style: {"width":"100px"},
              size: "mini",
              onChange: getData,
              modelValue: year.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((year).value = $event)),
              "value-format": "YYYY",
              type: "year",
              placeholder: "选择年"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (currentType.value === 'month')
          ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 1,
              style: {"width":"110px"},
              size: "mini",
              onChange: getData,
              modelValue: month.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((month).value = $event)),
              "value-format": "YYYY-MM",
              type: "month",
              placeholder: "选择月"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_select, {
          style: {"width":"110px"},
          modelValue: currentOption.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentOption).value = $event)),
          size: "mini",
          onChange: getData,
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value.filter((item) => item.type === 'option'), (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.sqlCol,
                label: item.label,
                value: item.sqlCol
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value.filter(
            (item) => item.type != 'option' || item.sqlCol === currentOption.value
          ), (column, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "card-item-column"
            }, [
              _createElementVNode("span", null, _toDisplayString(column.label), 1)
            ]))
          }), 128))
        ]),
        (dataList.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_empty, { description: "暂无数据" })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "card-content",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value.filter(
                (item) => item.type != 'option' || item.sqlCol === currentOption.value
              ), (column, colIdx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: colIdx,
                        class: "card-item-column"
                      }, [
                        (column.prop != 'rank')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item[column.prop]), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                              (index === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                    _createVNode(_component_el_image, {
                                      class: "medal",
                                      src: require('@/assets/images/b-medal-gold.png')
                                    }, null, 8, ["src"])
                                  ]))
                                : (index === 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                      _createVNode(_component_el_image, {
                                        class: "medal",
                                        src: require('@/assets/images/b-medal-silver.png')
                                      }, null, 8, ["src"])
                                    ]))
                                  : (index === 2)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                        _createVNode(_component_el_image, {
                                          class: "medal",
                                          src: require('@/assets/images/b-medal-copper.png')
                                        }, null, 8, ["src"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(index + 1), 1))
                            ]))
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]))
      ])
    ]),
    _: 1
  }))
}
}

})